import { Component } from "react"


/* The path of one star on a 24 by 24 grid */
const STAR = "M12 2.6l2.85 5.95 6.55.85-4.8 4.55 1.2 6.5L12 17.3l-5.8 3.15 1.2-6.5-4.8-4.55 6.55-.85z"


/* Widget Stars — the rate in five stars. A rate with a fraction (the average of a point) fills
   the last star partly. With onChange the stars are pressed: the hand over a star lights all
   the stars up to it before the press */
class Stars extends Component {

    constructor() {
        super()

        this.state = {
            hover: 0
        }
    }

    render = () => {

        /* Fields */
        const { value, size, onChange, className } = this.props
        const { hover } = this.state

        const shown = hover > 0 ? hover : parseFloat(value) || 0
        const pixels = size ? size : 16

        return (
            <div className={`review-stars-line ${onChange ? "editable" : ""} ${className ? className : ""}`} onMouseLeave={() => onChange && this.setState({ hover: 0 })}>
                {[1, 2, 3, 4, 5].map(star => {

                    const fill = Math.max(0, Math.min(1, shown - star + 1)) * 100

                    return (
                        <div
                            key={`${star}`}
                            className="review-stars-star"
                            style={{ width: pixels, height: pixels }}
                            onMouseEnter={() => onChange && this.setState({ hover: star })}
                            onClick={() => onChange && onChange(star)}
                        >
                            <svg viewBox="0 0 24 24" className="empty"><path d={STAR} /></svg>
                            <div className="review-stars-fill" style={{ width: `${fill}%` }}>
                                <svg viewBox="0 0 24 24" style={{ width: pixels, height: pixels }}><path d={STAR} /></svg>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}

export default Stars
